import { usePipelineQuery, useCreatePipelineMutation, useUpdatePipelineMutation, useDeletePipelineMutation } from './usePipelinesQuery';
import { Pipeline } from '../types';

export const usePipeline = (pipelineId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = usePipelineQuery(pipelineId || '');
    const createPipelineMutation = useCreatePipelineMutation();
    const updatePipelineMutation = useUpdatePipelineMutation();
    const deletePipelineMutation = useDeletePipelineMutation();

    const createRecord = async (values: Pipeline) => {
        return await createPipelineMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Pipeline) => {
        if (typeof pipelineId === 'undefined') {
            throw new Error('pipelineId is required parameter');
        }
        return await updatePipelineMutation.mutateAsync({ id: pipelineId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof pipelineId === 'undefined') {
            throw new Error('pipelineId is required parameter');
        }
        return await deletePipelineMutation.mutateAsync(pipelineId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
